import mixpanel from "mixpanel-browser";
import { getEnv } from "helpers/env";

const initMixpanelTracker = () => {
  mixpanel.init(
    getEnv() === "production"
      ? "73d911fcd247037193404ee54ca34050"
      : "86a764ad97c52ad199cc8ed33854fe82",
    { persistence: "localStorage" }
  );
};

const Mixpanel = {
  identify: (id: string) => {
    mixpanel.identify(id);
  },
  track: (name: string, props: Record<string, unknown>) => {
    mixpanel.track(name, {
      ...props,
      platform: (window as Window & { ReactNativeWebView?: unknown })
        .ReactNativeWebView
        ? "mobileWeb"
        : "web",
    });
  },
  reset: () => {
    mixpanel.reset();
  },
};

export { initMixpanelTracker, Mixpanel };
